import ServicesReducer from './services_reducer';

export default ServicesReducer;
